import React from 'react';
import PartnerListPage from '../domains/partners/components/PartnerListPage';

const AdminPartners: React.FC = () => <PartnerListPage />;

export default AdminPartners;
